import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { disposables as f } from '../../../utils/disposables.js';
import { match as d } from '../../../utils/match.js';
import { once as s } from '../../../utils/once.js';
function g(t) {
  var _t$classList;
  for (var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    e[_key - 1] = arguments[_key];
  }
  t && e.length > 0 && (_t$classList = t.classList).add.apply(_t$classList, e);
}
function v(t) {
  var _t$classList2;
  for (var _len2 = arguments.length, e = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    e[_key2 - 1] = arguments[_key2];
  }
  t && e.length > 0 && (_t$classList2 = t.classList).remove.apply(_t$classList2, e);
}
function b(t, e) {
  var n = f();
  if (!t) return n.dispose;
  var _getComputedStyle = getComputedStyle(t),
    m = _getComputedStyle.transitionDuration,
    a = _getComputedStyle.transitionDelay,
    _map = [m, a].map(function (l) {
      var _l$split$filter$map$s = l.split(",").filter(Boolean).map(function (i) {
          return i.includes("ms") ? parseFloat(i) : parseFloat(i) * 1e3;
        }).sort(function (i, T) {
          return T - i;
        }),
        _l$split$filter$map$s2 = _slicedToArray(_l$split$filter$map$s, 1),
        _l$split$filter$map$s3 = _l$split$filter$map$s2[0],
        r = _l$split$filter$map$s3 === void 0 ? 0 : _l$split$filter$map$s3;
      return r;
    }),
    _map2 = _slicedToArray(_map, 2),
    u = _map2[0],
    p = _map2[1],
    o = u + p;
  if (o !== 0) {
    n.group(function (r) {
      r.setTimeout(function () {
        e(), r.dispose();
      }, o), r.addEventListener(t, "transitionrun", function (i) {
        i.target === i.currentTarget && r.dispose();
      });
    });
    var l = n.addEventListener(t, "transitionend", function (r) {
      r.target === r.currentTarget && (e(), l());
    });
  } else e();
  return n.add(function () {
    return e();
  }), n.dispose;
}
function M(t, e, n, m) {
  var a = n ? "enter" : "leave",
    u = f(),
    p = m !== void 0 ? s(m) : function () {};
  a === "enter" && (t.removeAttribute("hidden"), t.style.display = "");
  var o = d(a, {
      enter: function enter() {
        return e.enter;
      },
      leave: function leave() {
        return e.leave;
      }
    }),
    l = d(a, {
      enter: function enter() {
        return e.enterTo;
      },
      leave: function leave() {
        return e.leaveTo;
      }
    }),
    r = d(a, {
      enter: function enter() {
        return e.enterFrom;
      },
      leave: function leave() {
        return e.leaveFrom;
      }
    });
  return v.apply(void 0, [t].concat(_toConsumableArray(e.base), _toConsumableArray(e.enter), _toConsumableArray(e.enterTo), _toConsumableArray(e.enterFrom), _toConsumableArray(e.leave), _toConsumableArray(e.leaveFrom), _toConsumableArray(e.leaveTo), _toConsumableArray(e.entered))), g.apply(void 0, [t].concat(_toConsumableArray(e.base), _toConsumableArray(o), _toConsumableArray(r))), u.nextFrame(function () {
    v.apply(void 0, [t].concat(_toConsumableArray(e.base), _toConsumableArray(o), _toConsumableArray(r))), g.apply(void 0, [t].concat(_toConsumableArray(e.base), _toConsumableArray(o), _toConsumableArray(l))), b(t, function () {
      return v.apply(void 0, [t].concat(_toConsumableArray(e.base), _toConsumableArray(o))), g.apply(void 0, [t].concat(_toConsumableArray(e.base), _toConsumableArray(e.entered))), p();
    });
  }), u.dispose;
}
export { M as transition };